import {
  AdminPartnerProviderConfiguration,
  UpsertAdminPartnerProviderRequest,
} from "@/types/admin-partner-provider";
import { BaseService } from "./BaseService";

class AdminPartnersService extends BaseService {
  private basePath = "/admin/partners/providers";

  async listProviders(): Promise<AdminPartnerProviderConfiguration[]> {
    return this.get<AdminPartnerProviderConfiguration[]>(this.basePath);
  }

  async upsertProvider(
    provider: string,
    data: UpsertAdminPartnerProviderRequest,
  ): Promise<AdminPartnerProviderConfiguration> {
    return this.put<AdminPartnerProviderConfiguration>(
      `${this.basePath}/${provider}`,
      data,
    );
  }

  async enableProvider(provider: string): Promise<void> {
    return this.patch<void>(`${this.basePath}/${provider}/enable`);
  }

  async disableProvider(provider: string): Promise<void> {
    return this.patch<void>(`${this.basePath}/${provider}/disable`);
  }
}

export const adminPartnersService = new AdminPartnersService();
